/**
 * What a key of the public API may do (decision 0031, D1). Each operation of the API asks for one
 * of these; a key does only what was ticked when it was made. The groups are the screen's.
 */
export const API_SCOPE_GROUPS = [
  { id: "campaigns", scopes: ["campaigns:read", "campaigns:write", "campaigns:send"] },
  {
    id: "contacts",
    scopes: ["contacts:read", "contacts:write", "fields:read", "fields:write", "contacts:delete"],
  },
  { id: "templates", scopes: ["templates:read", "templates:write"] },
  {
    id: "messages",
    scopes: [
      "messages:send_template",
      "messages:send_text",
      "conversations:read",
      "conversations:write",
      "conversations:export",
    ],
  },
  { id: "flows", scopes: ["flows:start", "appointments:read", "appointments:write"] },
  {
    id: "other",
    scopes: ["webhooks:manage", "reports:read", "workspace:read", "integrations:outboundpro"],
  },
] as const;

export type ApiScope = (typeof API_SCOPE_GROUPS)[number]["scopes"][number];
export const API_SCOPES: readonly ApiScope[] = API_SCOPE_GROUPS.flatMap((g) => g.scopes);

/** A key for production sends for real; a test key only simulates (decision 0031, D2). */
export const API_KEY_ENVIRONMENTS = ["live", "test"] as const;
export type ApiKeyEnvironment = (typeof API_KEY_ENVIRONMENTS)[number];
